export class CarModelPicture {
    public fileContent:string;
    public fileName:string;
}

export class CarModel {
    public oid?:number;
    public version?:number;
    public brand:string;
    public model:string;
    public category:string;
    public type:number;
    public picture: CarModelPicture;
    public auxPicture: CarModelPicture;

}

export class CarTemplate {
    public oid?:number;
    public carModel:CarModel;
    public airConditioning:boolean;
    public transmission:string;
    public passengers:number;
    public largeBags:number;
    public smallBags:number;
    public doors:number;
    public approvalStatus:string;
    public active:boolean;
    public creationDate?: any;
    public createdByCompany?: number;
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/carTemplate/model/car-template.ts